import { Tooltip, TooltipProps, tooltipClasses } from "@digitalreality/ui";
import React from "react";
import { styled } from "@digitalreality/ui";
import { pangeaUIColors } from "../Helpers/Colors";

// Override styles for DigitalRealityUI Tooltip to be consistent with provided design
const CustomTooltip = styled(({ className, color, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    classes={{
      popper: className,
    }}
  />
))(({}) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: pangeaUIColors.grey[850],
    color: pangeaUIColors.whiteOp[600],
    fontFamily: "Roboto",
    fontSize: "14px",
    fontStyle: "italic",
    fontWeight: 400,
    lineHeight: "24px",
    padding: "12px",
    maxWidth: 320,
    border: "1px solid transparent",
    borderRadius: "6px",
    boxShadow:
      "0px 0px 1px 0px rgba(0, 0, 0, 0.40), 0px 6px 6px -6px rgba(0, 0, 0, 0.16)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: pangeaUIColors.grey[850],
  },
  [`& .${tooltipClasses.tooltipPlacementBottom}`]: {
    marginTop: "16px !important",
  },
  "&[data-popper-placement*=bottom-end]": {
    [`& .${tooltipClasses.tooltip}`]: {
      right: "-15px",
    },
    [`& .${tooltipClasses.arrow}`]: {
      left: "-15px !important",
    },
  },
}));

export default CustomTooltip;
